"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ButtonStyled = require("./ButtonStyled");
Object.keys(_ButtonStyled).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ButtonStyled[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ButtonStyled[key];
    }
  });
});